/** Full English month names only (calendar filter / sheet Month column). */
export const CALENDAR_MONTHS_ORDER = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const LOWER_TO_CANONICAL = new Map(
  CALENDAR_MONTHS_ORDER.map(m => [m.toLowerCase(), m])
);

/** Common English abbreviations / short forms from spreadsheets. */
const ABBREV_TO_CANONICAL = new Map([
  ['jan', 'January'],
  ['feb', 'February'],
  ['mar', 'March'],
  ['apr', 'April'],
  ['may', 'May'],
  ['jun', 'June'],
  ['jul', 'July'],
  ['aug', 'August'],
  ['sep', 'September'],
  ['sept', 'September'],
  ['oct', 'October'],
  ['nov', 'November'],
  ['dec', 'December'],
]);

/**
 * Maps a sheet value to a canonical month name, or '' if not a real month.
 */
export function normalizeCalendarMonth(value) {
  if (value === undefined || value === null) return '';
  if (typeof value === 'number' && Number.isFinite(value)) {
    const n = Math.trunc(value);
    if (n >= 1 && n <= 12) return CALENDAR_MONTHS_ORDER[n - 1];
    return '';
  }
  const s = String(value).trim();
  if (!s) return '';
  const lower = s.toLowerCase().replace(/\.$/, '');
  const full = LOWER_TO_CANONICAL.get(lower);
  if (full) return full;
  const fromAbbrev = ABBREV_TO_CANONICAL.get(lower.slice(0, 3)) || ABBREV_TO_CANONICAL.get(lower);
  if (fromAbbrev) return fromAbbrev;
  const n = parseInt(lower, 10);
  if (!Number.isNaN(n) && n >= 1 && n <= 12 && /^\d{1,2}$/.test(lower)) {
    return CALENDAR_MONTHS_ORDER[n - 1];
  }
  return '';
}
